import React,{useEffect,useState} from 'react'
import { Link } from 'react-router-dom'
const SocialLink = ({socialLink}) => {
    const [socialText,setSocialText] = useState()
    const [socialIcon,setSocialIcon] = useState()

    useEffect(()=>{
       //console.log(socialLink)
    },[])
    return ( 
        <>
            
            <div className="col-3">
                <div className="card">
                    <div className="card-body">
                    {socialLink.linkType=='GOOGLE'?
                            <p className="card-text">
                            If you have a Google or Gmail account and would like to rate us on <strong>GOOGLE MY BUSINESS,</strong> please click the icon below:
                            </p>                        
                        : socialLink.linkType=='FACEBOOK'?
                                <p className="card-text">
                                If you have a Facebook account and would like to rate us on <strong>FACEBOOK,</strong> please click the icon below:
                            </p>   
                        : socialLink.linkType=='YELP'?
                            <p className='card-text'>
                                If you have a Yelp account and would like to rate us on <strong>Yelp,</strong> please click the icon below:
                            </p>
                        :""
                     }
                         <a href={socialLink.link}>{socialLink.linkType=='GOOGLE'?<h1 className='bi bi-google'></h1>: socialLink.linkType=='FACEBOOK'?<h1 className='bi bi-facebook'></h1>:<h1 className='bi bi-yelp'></h1> }</a> 
                    </div>
                </div>
               
            </div>
        </>
     );
}
 
export default SocialLink;